import { observer } from 'mobx-react-lite';
import React from 'react';

import { Tag } from '@flixbus/honeycomb-react';

import { crewMemberActionLogStore } from 'pages/CrewMemberDetails/components/CrewMemberActionLog/CrewMemberActionLogStore';
import {
	typesGrouped,
	typeTags,
} from 'pages/CrewMemberDetails/components/CrewMemberActionLog/groupedFilterTypes';

import styles from './styles.module.css';

const CrewLogTypeTag = observer(({ type }) => (
	<Tag
		Elem="button"
		display="subtle"
		appearance="neutral"
		small
		extraClasses={styles.categoryTag}
		onClick={() => crewMemberActionLogStore.setSelectedTypes(typesGrouped[type])}
	>
		{typeTags[type]}
	</Tag>
));

export const renderCrewLogTypeTag = (type) => {
	switch (type) {
		case 'CrewMemberAbsenceLog':
			return <CrewLogTypeTag type="absence" />;
		case 'CrewMemberInfoUpdatedLog':
		case 'CrewMemberEmploymentTypeLog':
		case 'CrewMemberLocationChangeLog':
			return <CrewLogTypeTag type="info" />;
		case 'CrewMemberHomeBaseLog':
			return <CrewLogTypeTag type="info" />;
		case 'CrewMemberHoldDownLog':
			return <CrewLogTypeTag type="holdDown" />;
		case 'WorkAssignmentCreatedLog':
		case 'WorkAssignmentStatusUpdatedLog':
		case 'WorkAssignmentTimeUpdatedLog':
		case 'WorkAssignmentActualCreatedLog':
			return <CrewLogTypeTag type="assignment" />;
		case 'WorkAssignmentBreakdownLog':
			return <CrewLogTypeTag type="breakdown" />;
		default:
			return <CrewLogTypeTag type="info" />;
	}
};
